import Repository from './Repository';
const LOGIN = '/user/login';
export default {
  login(payload) {
    return Repository.post(`${LOGIN}`, payload);
  }
};
